import React from "react";
import { Form, Select } from "antd";
import { TimeZone } from "../../../common/Countries";
import { createUseStyles } from "react-jss";

const UITimeZonePicker = ({
  label,
  name,
  required,
  defaultValue,
  rules,
  index,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  initialValue,
}) => {
  const styles = useStyles();
  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue}
    >
      <Select
        showSearch
        placeholder="Select TimeZone"
        onChange={onChange}
        allowClear
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        className={styles.customSelect}
      >
        {Object.values(TimeZone)?.map((item, index) => {
          return (
            <Select.Option key={index} value={Object.keys(TimeZone)[index]}>
              {item}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default UITimeZonePicker;
const useStyles = createUseStyles({
  customSelect : {
    height: "51px !important",
    '& .ant-select-selector': {
      height: "50px",
      fontSize: "16px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
    },
    '& .ant-select-selection-item': {
      fontSize: "16px",
      fontWeight: 500,
    },
    '& .ant-select-selection-placeholder': {
      fontSize: "16px",
      fontWeight: 500,
    },
  }
});